export default __webpack_public_path__ + "static/media/2930 spice rack F side.bcfdbf37.png";